import styled from "styled-components";

export const RenderOptionContent = styled.div.attrs({})`
  display: flex;
  border-radius: 6px;
  background: ${p => p.theme.palette.colors.shadow};
  padding: 1px .5px;
  height: 40px;
  flex-shrink: 0;
`;

export const RenderOption = styled.div.attrs({})`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  width: 40px;
  flex-shrink: 0;
  margin: 0px .5px;
  border-radius: ${p => p.left ? '6px 0px 0px 6px' : '0px 6px 6px 0px'};
  background: ${p => p.theme.palette.colors.white};
  cursor: pointer;
  transition: all 0.35s;
  ${p => p.active ? `
       background:${p.theme.palette.colors.backgroundgrey}
    ` : ``};
`;

export const PaginationContainer = styled.div.attrs({})`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
